/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class StorageConfigurationBaseForOciSaas extends models.StorageConfigurationForSaasUserManaged {
    getFixupPrototypeFunction() { return StorageConfigurationBaseForOciSaas.fixupPrototype; }

    static newInstance(model: Partial<StorageConfigurationBaseForOciSaas>): StorageConfigurationBaseForOciSaas {
        let obj = Object.assign(new StorageConfigurationBaseForOciSaas(), model);
        StorageConfigurationBaseForOciSaas.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<StorageConfigurationBaseForOciSaas>): StorageConfigurationBaseForOciSaas {
        if (!model) return null;
        return StorageConfigurationBaseForOciSaas.newInstance(<StorageConfigurationBaseForOciSaas> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: StorageConfigurationBaseForOciSaas) {
        if (!obj) return;

        models.StorageConfigurationBaseForOciSaas.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: StorageConfigurationBaseForOciSaas): boolean {
        if (models.StorageConfigurationForSaasUserManaged.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, StorageConfigurationBaseForOciSaas.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * OCI Bucket Name
     */
    bucket_name: string;

    /**
     * File Path in the Bucket
     */
    file_path: string;

}
